import SelfAssignRegistration from './SelfAssignRegistration';

export default SelfAssignRegistration;
